<div class="container" id="page-not-found">
  <div class="page-not-found-content registrationBox">
    <p>Sorry, we can’t seem to find the page you are looking for</p>
    <a class="button__nc button" href="https://signup.naturalcycles.com">Back to site</a>
  </div>
</div>
